export var SlotsOffering;
(function (SlotsOffering) {
    SlotsOffering.ValueEnum = {
        Cleveron: 'Cleveron',
        ELocker: 'ELocker',
        InStore: 'InStore',
        DirectToBoot: 'DirectToBoot',
        DriveUp: 'DriveUp',
        DriveThrough: 'DriveThrough'
    };
})(SlotsOffering || (SlotsOffering = {}));
